// extracted by mini-css-extract-plugin
export var footer = "_mo-5";
export var fulfillmentInput = "_mo-0";
export var shipDateInput = "_mo-1";
export var shipmentModal = "_mo-2";
export var shipmentModalContent = "_mo-3";
export var tableContainer = "_mo-4";